// features/editMood/selectors.js
import getCauseTypesByIds from "utils/causes/getCauseTypesByIds";
import { isSameDay } from "utils/common/weekUtils";

export async function buildCausesToOffer(
  causes = [],
  activeCauseTypes = [],
  feelingName,
  t,
  existingCauseIds = [],
  activeTeamCauseTypes, // can be { causeTypes: [...] } or [ { causeTypes: [...] }, ... ]
  selectedDate
) {
  console.log(
    "debug buildCausesToOffer activeCauseTypes -> " + activeCauseTypes
  );
  try {
    // 3) Merge with activeCauseTypes and de-duplicate by "id"
    const merged = [
      ...(activeCauseTypes || []),
      ...(activeTeamCauseTypes || []),
    ];

    console.log("debug buildCausesToOffer merged " + merged.length);

    const uniqueMerged = merged.filter(
      (item, index, self) =>
        item && item.id && index === self.findIndex((t) => t?.id === item.id)
    );

    console.log("debug buildCausesToOffer uniqueMerged " + uniqueMerged.length);

    // 4) Filter by mood
    const relevantForMood = (uniqueMerged || []).filter(
      (cause) => cause?.mood === feelingName
    );

    console.log(
      "debug buildCausesToOffer relevantForMood " + relevantForMood.length
    );

    console.log("check causes: " + JSON.stringify(causes));
    // 5) Compute existing IDs (prefer explicit arg, otherwise derive from "causes" filtered by selectedDate)
    // Helper to normalize Firestore timestamp to Date
    const normalizeTimestamp = (ts) => {
      if (!ts) return null;
      if (typeof ts.toDate === "function") {
        return ts.toDate();
      }
      if (ts.seconds) {
        return new Date(ts.seconds * 1000);
      }
      return new Date(ts);
    };

    // Filter causes by selectedDate if provided
    const causesForDate = selectedDate
      ? causes.filter((c) => {
          if (!c?.timestamp) return false;
          const causeDate = normalizeTimestamp(c.timestamp);
          if (!causeDate || isNaN(causeDate.getTime())) return false;
          return isSameDay(causeDate, selectedDate);
        })
      : causes;

    const existingIds =
      existingCauseIds && existingCauseIds.length > 0
        ? existingCauseIds
        : causesForDate.map((c) => c?.causeTypeId).filter(Boolean);

    console.log("debug buildCausesToOffer existingIds " + existingIds.length);

    console.log("zzz");
    // 6) Remove already existing

    console.log("asdf: " + existingIds);

    console.log("debug buildCausesToOffer causes -> " + JSON.stringify(causes));
    console.log("debug buildCausesToOffer selectedDate -> " + selectedDate);

    const toOffer = relevantForMood.filter(
      (c) => c?.id && !existingIds.includes(c.id)
    );

    console.log("debug buildCausesToOffer toOffer " + toOffer.length);

    return toOffer;
  } catch (error) {
    console.error("[buildCausesToOffer] Error:", error);
  }
}
